import React, { FC, ReactElement } from 'react'
import Value from './value'

const Satoshis: FC<{
	className?: string
	iconClassName?: string
	skeleClassName?: string
	satoshis: number
	force?: 'USD' | 'BTC'
	isLoading?: boolean
}> = (props): ReactElement => {
	return (
		<Value
			className={props.className}
			iconClassName={props.iconClassName}
			skeleClassName={props.skeleClassName}
			satoshis={props.satoshis}
			force={props.force}
			isLoading={props.isLoading}
		/>
	)
}

export default Satoshis
